import cloneDeep from 'lodash/cloneDeep';
import { APP_ERROR, TOGGLE_APP_ERROR_VISIBILITY, CLEAR_ALL_ERRORS } from './constants';

export const initialState = {};

function appReducer(state = initialState, action) {
  let nextState = state;
  switch (action.type) {
    case APP_ERROR:
      nextState = {
        errors: cloneDeep(state.errors || []),
      };
      nextState.errors.push(action);
      break;
    case TOGGLE_APP_ERROR_VISIBILITY:
      nextState = {
        ...{ errors: [] },
        ...state,
      };
      nextState.errors = nextState.errors.map((err) => {
        if (err.id === action.id) {
          return {
            ...err,
            visible: !err.visible,
          };
        }
        return err;
      });
      break;
    case CLEAR_ALL_ERRORS:
      nextState = { ...state, errors: [] };
      break;
    default:
      nextState = state;
  }
  return nextState;
}

export default appReducer;



// WEBPACK FOOTER //
// ./src/containers/App/reducer.js